// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogFilterBox_card__qMzbp","warning-letter-filter-wrapper":"BlogFilterBox_warning-letter-filter-wrapper__20Q2Q"};